/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Email_TooltipInputs */

const en_claims_email_tooltip = /** @type {(inputs: Claims_Email_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email must be primary email that was used to purchase the insurance policy`)
};

const fr_claims_email_tooltip = /** @type {(inputs: Claims_Email_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'adresse courriel doit être l'adresse principale utilisée lors de l'achat de la police d'assurance`)
};

/**
* | output |
* | --- |
* | "The email must be primary email that was used to purchase the insurance policy" |
*
* @param {Claims_Email_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_email_tooltip = /** @type {((inputs?: Claims_Email_TooltipInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Email_TooltipInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_email_tooltip(inputs)
	return fr_claims_email_tooltip(inputs)
});